function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.set.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.symbol.iterator.js";
import "core-js/modules/es.array.from.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.regexp.test.js";
import "core-js/modules/es.error.cause.js";
import styled from "styled-components";
import { colorPropsNoForward, colors, composeEnhancers, display, displayPropsNoForward, flexbox, flexboxPropsNoForward, sizePropsNoForward, sizes, spacingWithoutGap, text, textPropsNoForward } from "../core/enhancers";
import createStyledEnhancer from "../core/enhancers/helpers/createStyledEnhancer";

/**
 * Названия пропсов из каждой используемой группы энхенсеров, которые нужно
 * фильтровать, чтоб styled их не сетил в атрибуты
 */
var propsNoForward = new Set([].concat(_toConsumableArray(textPropsNoForward), _toConsumableArray(displayPropsNoForward), _toConsumableArray(sizePropsNoForward), _toConsumableArray(flexboxPropsNoForward), _toConsumableArray(colorPropsNoForward)));
var sizeEnhacer = createStyledEnhancer({
  name: "size",
  directTransformation: true,
  transformation: function transformation(value, _ref) {
    var theme = _ref.theme;
    // TODO: сделать createStyledEnhancer дженериком  возможностью принимать тип value
    var typedValue = value;

    if (typedValue) {
      return {
        fontSize: theme.font.sizes[typedValue].fontSize,
        lineHeight: theme.font.sizes[typedValue].lineHeight
      };
    }

    return {};
  }
});
var composedEnhancers = composeEnhancers(text, display, sizes, flexbox, colors, spacingWithoutGap);
var Font = styled.span.withConfig({
  shouldForwardProp: function shouldForwardProp(propertyName, defaultValidator) {
    return !propsNoForward.has(propertyName) && defaultValidator(propertyName);
  }
}).withConfig({
  displayName: "Font",
  componentId: "sc-le1wax-0"
})(["box-sizing:border-box;", ";", ";"], sizeEnhacer, composedEnhancers);
export default Font;